import React from "react";

import ItemList, { Item } from "../../ItemList/ItemList";

import styles from "./GuideList.module.scss";

interface GuideListProps {
  items: Item[];
}

export default function GuideList({
  items,
}: GuideListProps): React.ReactElement {
  return (
    <div className={styles.guideList} data-testid="guide-list">
      {items.length > 0 && <ItemList items={items} />}
    </div>
  );
}
